<template>
    <label class="block select-none text-sm text-gray-700">
        <slot />
    </label>
</template>

<script setup lang="ts"></script>
